import { isEmpty } from '@sgme/fp';
import { SecondaryCellRendererProps } from 'routes/secondary-market-batch/grid/types';

export function StatusCellRenderer({ colDef, value }: SecondaryCellRendererProps<string>) {
  if (isEmpty(value)) {
    return;
  }
  const color = colDef.context.semanticColorsByStatus?.[value];

  return <span className={`badge rounded-pill badge-sm p-2 badge-discreet-${color}`}>{value} </span>;
}
